import styled, { css } from 'styled-components';

import {
    Col,
} from '@zillow/zrs-comet';

// Constellation Components
import {
    Button,
    mediaMixin,
    spaceMixin,
} from '@zillow/constellation';

export const StyledAddAmenityInputCol = styled(Col)`
    margin-bottom: ${spaceMixin(0.5)};
    width: 100%;
    display: block;
    ${mediaMixin('lg', css`
        margin-bottom: 0;
        max-width: 500px;
        display: inline-block;
    `)};
`;

export const StyledBoldButton = styled(Button)`
    border-radius: 0 3px 3px 0;
    font-weight: bold;
`;

export const StyledItemTagButton = styled(Button)`
    background: ${props => props.theme.ns().colors.gray300};
    border: 1px solid ${props => props.theme.ns().colors.gray300};
    ${props => props.theme.ns().spacing.getSpacingMixin()};
    min-width: 0;
    height: auto;
    line-height: 24px;
    &:hover{
        background: linear-gradient(
            180deg,
            ${props => props.theme.ns().colors.gray300},
            ${props => props.theme.ns().colors.gray400}
        );
        border: 1px solid ${props => props.theme.ns().colors.gray300};
        background-color: ${props => props.theme.ns().colors.gray400};
        background-repeat: repeat-x;
    }
`;

export const StyledAvailableUnitsCol = styled(Col)`
    ${mediaMixin('xs', css`
        display: block;
        text-align: right;
    `)};

    ${mediaMixin('sm', css`
        display: block;
    `)};

`;

export const StyledTagArrayDiv = styled.div`
    overflow: auto;
    button:last-child {
        margin-right: 0;
    }
`;
